<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar />
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav
          style="justify-content: flex-start"
          class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating"
        >
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar">
              <span class="navbar-toggler-icon"></span>
            </button>

            <button
              style="
                color: rgba(0, 0, 0, 0.5);
                border-color: rgba(0, 0, 0, 0.1);
              "
              class="btn btn-outline navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span style="padding-top: 0.5em"
                ><i class="fas fa-user-alt"></i><span class="account-div"></span
                ><i class="fas fa-angle-down"></i
              ></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp;Order</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ admin }}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <a class="dropdown-item link" @click="toPage('/password')">
                    <i class="fas fa-cog"></i
                    ><span class="right-dropdown">Change Password</span></a
                  >
                  <a class="dropdown-item link" @click="handleLogout"
                    ><i class="fas fa-sign-out-alt"></i
                    ><span class="right-dropdown">Logout</span></a
                  >
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 grid-margin stretch-card card-div">
              <div>
                <h5 class="card-title mb-4">Order {{ statusOrder }}</h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <div class="col-sm mobile-div">
                      Order ID
                      <input
                        type="text"
                        class="form-control w-100"
                        v-model="orderId"
                        placeholder="Order ID"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      Company Name
                      <input
                        type="text"
                        class="form-control w-100"
                        v-model="companyName"
                        placeholder="Company Name"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      Status
                      <multiselect
                        v-model="searchStatus"
                        :options="statusSelect"
                        label="statusName"
                        :allow-empty="true"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="All"
                        track-by="statusName"
                        :multiple="true"
                        :taggable="true"
                        :close-on-select="false"
                        group-values="libs"
                        group-label="statusAll"
                        :group-select="true"
                      >
                      </multiselect>
                    </div>
                    <div class="col-sm mobile-div">
                      PIC Name
                      <multiselect
                        class="w-100"
                        v-model="searchPic"
                        :options="picSelect"
                        label="picName"
                        :allow-empty="false"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="PIC Name"
                        track-by="picName"
                      ></multiselect>
                    </div>
                    <div class="col-lg-2 col-sm mt-4 mobile-div">
                      <!-- <button class="btn btn-primary w-75" @click="toPage('/order/endrent')"> End Rent </button> -->
                      <button class="btn btn-primary w-75" @click="searchData">
                        Search
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm mobile-div">
                      Start Rent (from)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="deliver_schedule"
                        v-model="startRentFrom"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      Start Rent (to)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="deliver_schedule"
                        v-model="startRentTo"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      End Rent (from)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="pickup_schedule"
                        v-model="endRentFrom"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      End Rent (to)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="pickup_schedule"
                        v-model="endRentTo"
                      />
                    </div>
                    <div class="col-lg-2 col-sm mt-4 mobile-div">
                      <button class="btn btn-primary w-75" @click="resetFilter">
                        Reset
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm mobile-div">
                      Sort By
                      <multiselect
                        v-model="sortByValue"
                        :options="sortByOptions"
                        :allow-empty="true"
                        label="label"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="Sort By"
                        track-by="value"
                        :multiple="false"
                        :taggable="false"
                        :close-on-select="true"
                        :group-select="false"
                        :selectedLabel="''"
                      >
                      </multiselect>
                    </div>
                    <div class="col-sm mobile-div">
                      Tags
                      <multiselect
                        v-model="tagSearch"
                        :options="dataTag"
                        :allow-empty="true"
                        label="label"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="All"
                        track-by="tagId"
                        :multiple="true"
                        :taggable="true"
                        :close-on-select="false"
                        :group-select="true"
                      >
                      </multiselect>
                    </div>
                    <div class="col-sm col-sm mobile-div">
                      Batch
                      <input
                        type="text"
                        class="form-control w-100"
                        v-model="searchBatch"
                        placeholder="Batch"
                        @keypress="isNumber($event)"
                      />
                    </div>
                    <div class="col-sm col-sm mobile-div"></div>
                    <div class="col-sm col-sm mobile-div"></div>
                    <div class="col-lg-2 col-sm mt-4 mobile-div">
                      <!-- <button class="btn btn-primary w-75" @click="searchData"> Search </button> -->
                    </div>
                  </div>
                  <div class="mt-3 mobile-div">
                    <button
                      class="btn btn-sm btn-primary mb-1 py-2"
                      @click="toPage('/order/create')"
                    >
                      Create Order
                    </button>
                  </div>
                </div>
                <table
                  class="table table-sm table-bordered table-striped table-responsive-sm"
                >
                  <thead class="">
                    <tr>
                      <th>Company Name</th>
                      <th>Tag</th>
                      <th>Order ID</th>
                      <th>Batch</th>
                      <th>Order Details</th>
                      <th style="width: 95px">Start Rent</th>
                      <th style="width: 95px">End Rent</th>
                      <th style="width: 95px">Payment Date</th>
                      <th style="width: 95px">Submit Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == true">
                      <td colspan="9" class="text-center">
                        <img src="~@/assets/images/load-button.gif" />
                      </td>
                    </tr>
                    <tr v-for="data in dataOrder" v-else :key="data.orderId">
                      <td>
                        <router-link
                          :to="{
                            path:
                              '/partnership/lessee/detail/' + data.companyId,
                            query: {
                              companyStatus: data.companyStatus,
                            },
                          }"
                        >
                          {{ data.companyName }}
                        </router-link>
                        <div
                          class="tagColumn"
                          v-for="tag in data.leseeTag"
                          :key="tag.tagId"
                        >
                          <div>
                            <span
                              class="tagBadge"
                              :style="'background-color :' + tag.colorHex + ';'"
                              >{{ tag.label }}</span
                            >
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          class="tagColumn"
                          v-for="(tag, index) in data.orderTag"
                          :key="index"
                        >
                          <div>
                            <span
                              class="tagBadge"
                              :style="'background-color :' + tag.colorHex + ';'"
                              >{{ tag.label }}</span
                            >
                          </div>
                        </div>
                        <button
                          v-if="allowUpdateOrderTag"
                          type="button"
                          class="btn btn-primary btnEdit-sm"
                          @click="openModal(data, data.currentTags)"
                        >
                          <img
                            src="~@/assets/icon/edit.png"
                            style="max-width: 12px"
                          />
                        </button>
                      </td>
                      <td>
                        <router-link
                          :to="{
                            path: '/order/detail/' + data.orderId,
                            query: {
                              orderCode: data.orderCode,
                              companyIdDetail: data.companyId,
                              tags:
                                data.leseeTag || data.orderTag ? true : false,
                            },
                          }"
                        >
                          {{ data.orderCode }}
                        </router-link>
                      </td>
                      <td>{{ data.batch }}</td>
                      <td>
                        <div
                          v-for="(detail, index) in data.orderDetails"
                          :key="index"
                        >
                          <span
                            >{{ detail.productTitle }} -
                            {{ detail.quantity }} Units</span
                          >
                        </div>
                      </td>
                      <td>{{ data.startRent }}</td>
                      <td>{{ data.endRent }}</td>
                      <td>{{ data.paymentDate }}</td>
                      <td>{{ data.submitDate }}</td>
                      <!-- STATUS COLUMN -->
                      <td v-if="data.status == 0">
                        <label class="badge badge-secondary">Pending</label>
                      </td>
                      <td v-if="data.status == 1">
                        <label class="badge badge-warning">On Process</label>
                      </td>
                      <td v-if="data.status == 2">
                        <label class="badge badge-warning"
                          >Quotation Review</label
                        >
                      </td>
                      <td v-if="data.status == 3">
                        <label class="badge badge-warning"
                          >Waiting for PO</label
                        >
                      </td>
                      <!-- <td v-if="data.status == 4"><label class="badge badge-warning">Agreement Review</label></td> -->
                      <td v-if="data.status == 5">
                        <label class="badge badge-warning"
                          >Waiting for Payment</label
                        >
                      </td>
                      <td v-if="data.status == 6">
                        <label class="badge badge-warning">Ready to Book</label>
                      </td>
                      <td v-if="data.status == 7">
                        <label class="badge badge-warning"
                          >Ready to Pickup</label
                        >
                      </td>
                      <td v-if="data.status == 8">
                        <label class="badge badge-warning">Picking Up</label>
                      </td>
                      <td v-if="data.status == 9 && data.finalPrepared">
                        <label class="badge badge-warning"
                          >Ready to Prepare (Final QC)</label
                        >
                      </td>
                      <td v-if="data.status == 9 && !data.finalPrepared">
                        <label class="badge badge-warning"
                          >Ready to Prepare</label
                        >
                      </td>
                      <td v-if="data.status == 10">
                        <label class="badge badge-warning">Prepared</label>
                      </td>
                      <td v-if="data.status == 11">
                        <label class="badge badge-info">Ready to Deliver</label>
                      </td>
                      <td v-if="data.status == 12">
                        <label class="badge badge-success">Shipping</label>
                      </td>
                      <td v-if="data.status == 13">
                        <label class="badge badge-success">Renting</label>
                      </td>
                      <td v-if="data.status == 14">
                        <label class="badge badge-success">Finished</label>
                      </td>
                      <td v-if="data.status == 15">
                        <label class="badge badge-success"
                          >Return Scheduled</label
                        >
                      </td>
                      <td v-if="data.status == 16">
                        <label class="badge badge-success">Return Assign</label>
                      </td>
                      <td v-if="data.status == 17">
                        <label class="badge badge-success">Return Match</label>
                      </td>
                      <td v-if="data.status == 18">
                        <label class="badge badge-danger">Return Unmatch</label>
                      </td>
                      <td v-if="data.status == 19">
                        <label class="badge badge-success">Completed</label>
                      </td>
                      <td v-if="data.status == 99">
                        <label class="badge badge-danger">Cancelled</label>
                      </td>
                      <!-- END OF STATUS COLUMN -->
                    </tr>
                    <tr v-if="dataOrder.length < 1 && loadingTable == false">
                      <td colspan="9" class="text-center">
                        Data Not Available
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1" style="display: inline-flex">
                    <div style="margin-right: 10px">
                      <select
                        class="form-control form-control-sm"
                        v-model="itemPerPage"
                        @change="showPage()"
                      >
                        <option value="10">10</option>
                        <option value="40">40</option>
                        <option value="80">80</option>
                      </select>
                    </div>
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }}
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a
                          class="is-active link"
                          @click="toDataPage(parseInt(currentPage) - 1)"
                          v-if="currentPage != 1"
                          ><li>&lt;</li></a
                        >
                        <a class="page"
                          ><li>{{ currentPage }} of {{ totalPage }} page</li></a
                        >
                        <a
                          class="is-active link"
                          @click="toDataPage(parseInt(currentPage) + 1)"
                          v-if="currentPage != totalPage"
                          ><li>></li></a
                        >
                      </ul>
                    </div>
                  </div>
                </div>
                ​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- modalEditOrderTag -->
      <div class="modal fade" id="modalEditOrderTag" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Edit Tag</h4>
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                @click="cancelUpdateTag()"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div v-for="data in dataOrderTag" :key="data.categoryId">
                <div class="row g-3 align-items-center mb-3">
                  <div class="col-2">
                    <label for="editTags" class="col-form-label">{{
                      data.categoryName
                    }}</label>
                  </div>
                  <div class="col-10">
                    <multiselect
                      :style="
                        tagOrderFieldError.indexOf(data.categoryName) >= 0
                          ? 'border: 1px solid red'
                          : ''
                      "
                      v-model="selectedOrderTag[data.categoryName]"
                      :options="data.tag"
                      label="label"
                      :allow-empty="true"
                      :multiple="true"
                      :select-label="''"
                      :deselect-label="''"
                      track-by="label"
                      :close-on-select="false"
                      @input="handleChangeChooseTag(data.categoryName)"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="row g-3" v-if="tagOrderFieldError.length > 0">
                <div class="col-2"></div>
                <div class="col-10">
                  <p style="color: red; font-size: 12px">
                    * Each category must have at least one tag
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                data-dismiss="modal"
                @click="cancelUpdateTag()"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="submitUpdatedOrderTag()"
                v-if="loadingButtonAdd == false"
              >
                Save
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                disabled
                v-else
              >
                <img src="~@/assets/images/2.gif" style="height: 24px" />Saving
              </button>
            </div>
          </div>
        </div>
      </div>
      <ModalEditTag
        @get-order-tags="getData"
        @req-close="onReqCloseModal"
        :companyId="companyId"
        :orderId="openedModalOrderId"
        :action="'listOrder'"
        :isOpen="isOpenTagModal"
        :orderStatus="statusSelectedOrder"
        :orderData="currentEditTagOrderData"
      />
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import { isArray } from "lodash";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import ModalEditTag from "./CustomComponent/ModalEditInvoiceTag.vue";

export default {
  name: "OrderPage",
  components: {
    SideBar,
    Multiselect,
    ModalEditTag,
  },
  data() {
    return {
      dataTag: [],
      statusSelectedOrder: 0,
      isOpenTagModal: false,
      sortByOptions: [
        {
          label: "Payment Date",
          value: "payment",
        },
        {
          label: "Submit Date",
          value: "submit",
        },
      ],
      companyId: 0,
      openedModalOrderId: 0,
      sortByValue: "",
      dataOrderTag: [],
      tagOptions: [],
      tagSearch: [],
      searchBatch: "",
      dataOrderTag: [],
      selectedOrder: {},
      selectedOrderTag: [],
      oldTags: [],
      loadingButtonAdd: false,
      admin: "",
      timer: "",
      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      allowUpdateOrderTag: false,
      dataOrder: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      orderId: "",
      companyName: "",
      statusOrder: "",
      loadingTable: true,
      searchPic: {
        picId: "All",
        picName: "All",
      },
      picSelect: [],
      searchStatus: [],
      statusSelect: [
        {
          statusAll: "All",
          libs: [
            {
              status: "0",
              statusName: "Pending",
            },
            {
              status: "1",
              statusName: "On Process",
            },
            {
              status: "2",
              statusName: "Quotation Review",
            },
            {
              status: "3",
              statusName: "Waiting for PO",
            },
            {
              status: "4",
              statusName: "Agreement Review",
            },
            {
              status: "5",
              statusName: "Waiting for Payment",
            },
            {
              status: "6",
              statusName: "Ready to Book",
            },
            {
              status: "7",
              statusName: "Ready to Pickup",
            },
            {
              status: "8",
              statusName: "Picking Up",
            },
            {
              status: "9",
              statusName: "Ready to Prepare",
            },
            {
              status: "9+",
              statusName: "Ready to Prepare (Final QC)",
            },
            {
              status: "10",
              statusName: "Prepared",
            },
            {
              status: "11",
              statusName: "Ready to Deliver",
            },
            {
              status: "12",
              statusName: "Shipping",
            },
            {
              status: "13",
              statusName: "Renting",
            },
            {
              status: "14",
              statusName: "Finished",
            },
            {
              status: "15",
              statusName: "Return Scheduled",
            },
            {
              status: "16",
              statusName: "Return Assign",
            },
            {
              status: "17",
              statusName: "Return Match",
            },
            {
              status: "18",
              statusName: "Return Unmatch",
            },
            {
              status: "19",
              statusName: "Completed",
            },
            {
              status: "99",
              statusName: "Cancelled",
            },
          ],
        },
      ],
      startRentFrom: "",
      startRentTo: "",
      endRentFrom: "",
      endRentTo: "",
      urlOrder: "",
      itemPerPage: 10,
      selectedCountries: [],
      countries: [],
      tagOrderFieldError: [],
      isOnTagOrderFieldError: false,
      currentEditTagOrderData: null,
    };
  },
  methods: {
    onReqCloseModal(type, isSuccess) {
      if (type === "submit" && isSuccess) {
        swal("Sukses", "Sukses menyimpan data", "success");
      }
      this.isOpenTagModal = false;
      this.statusSelectedOrder = 0;
    },
    formatDate(date) {
      if (!date) return "";
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    getTag() {
      this.$http
        .post(
          process.env.SEARCH_TAG,
          {
            target: "",
            label: "",
            categoryId: [],
            page: 1,
            itemPerPage: 1000,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
          } else {
            this.dataTag = response.data.content.data;
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    limitText(count) {
      return `and ${count} others`;
    },
    addTag(newTag) {
      const tag = {
        status: newTag,
        statusName:
          newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    showPage() {
      this.loadingTable = true;
      this.$router.push({
        path: "/order",
        query: {
          companyName: this.companyName,
          orderId: this.orderId,
          statusOrder: JSON.stringify(this.searchStatus),
          picId: this.searchPic.picId,
          picName: this.searchPic.picName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          tagOrder: JSON.stringify(this.tagSearch),
          batch: this.searchBatch,
          sortBy: this.sortByValue.value,
          page: 1,
        },
      });
      this.getData();
    },
    searchData() {
      this.$router.push({
        path: "/order",
        query: {
          companyName: this.companyName,
          orderId: this.orderId,
          statusOrder: JSON.stringify(this.searchStatus),
          picId: this.searchPic.picId,
          picName: this.searchPic.picName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          tagOrder: JSON.stringify(this.tagSearch),
          batch: this.searchBatch,
          sortBy: this.sortByValue.value,
          page: 1,
        },
      });
      this.getData();
    },
    resetFilter() {
      this.companyName = "";
      this.orderId = "";
      this.searchStatus = [];
      this.searchPic.picId = "";
      this.searchPic.picName = "";
      this.startRentFrom = "";
      this.startRentTo = "";
      this.endRentFrom = "";
      this.endRentTo = "";
      this.itemPerPage = 10;
      this.tagSearch = [];
      this.searchBatch = "";
      this.currentPage = 1;
      this.sortByValue = "";

      this.$router.push({
        path: "/order",
        query: {
          companyName: this.companyName,
          orderId: this.orderId,
          statusOrder: JSON.stringify(this.searchStatus),
          picId: this.searchPic.picId,
          picName: this.searchPic.picName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          tagOrder: JSON.stringify(this.tagSearch),
          batch: this.searchBatch,
          sortBy: this.sortByValue.value,
          page: 1,
        },
      });
      this.getData();
    },
    toDataPage(pagePost) {
      this.loadingTable = true;
      this.$router.push({
        path: "/order",
        query: {
          companyName: this.companyName,
          orderId: this.orderId,
          statusOrder: JSON.stringify(this.searchStatus),
          picId: this.searchPic.picId,
          picName: this.searchPic.picName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          tagOrder: JSON.stringify(this.tagSearch),
          batch: this.searchBatch,
          sortBy: this.sortByValue.value,
          page: pagePost,
        },
      });
      this.getData();
    },
    toPage(e) {
      if (e == "/product") {
        localStorage.setItem("itemPerPage", 10);
      }
      this.$router.push(e);
      localStorage.removeItem("endrent_cache");
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("endrent_cache");
      localStorage.removeItem("endrent_cache");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
        if (this.permission[i] == "2.3") {
          this.allowUpdateOrderTag = true;
        }
      }
      if (this.viewOrder == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toOrderDetail(data) {
      const { orderId, orderCode, companyId, leseeTag, orderTag } = data;
      let tags = false;
      if (leseeTag || orderTag) tags = true;
      this.$router.push({
        path: "/order/detail/" + orderId,
        query: {
          orderCode: orderCode,
          companyIdDetail: companyId,
          tags: tags,
        },
      });
    },
    charCount(str, letter) {
      var letter_Count = 0;
      for (var position = 0; position < str.length; position++) {
        if (str.charAt(position) == letter) {
          letter_Count += 1;
        }
      }
      return letter_Count;
    },
    sortTag(orderTags) {
      let result = {};
      if (orderTags) {
        let n = 0;
        while (n < orderTags.length) {
          for (let i = 0; i < this.dataOrderTag.length; i++) {
            if (
              this.dataOrderTag[i].tag.find(
                (e) => e.tagId == orderTags[n].tagId
              )
            ) {
              if (!result[this.dataOrderTag[i].categoryName]) {
                result[this.dataOrderTag[i].categoryName] = [orderTags[n]];
              } else {
                result[this.dataOrderTag[i].categoryName].push(orderTags[n]);
              }
              break;
            }
          }
          n++;
        }
      }
      return result;
    },
    getData() {
      this.loadingTable = true;
      this.dataOrder.length = 0;
      this.orderId = this.$route.query.orderId;
      this.companyName = this.$route.query.companyName;
      this.searchStatus = [];
      this.searchStatus = JSON.parse(this.$route.query.statusOrder);
      this.tagSearch = [];
      this.tagSearch = JSON.parse(this.$route.query.tagOrder);
      this.searchPic.picId = this.$route.query.picId;
      this.searchPic.picName = this.$route.query.picName;
      this.startRentFrom = this.$route.query.startRentFrom;
      this.startRentTo = this.$route.query.startRentTo;
      this.endRentFrom = this.$route.query.endRentFrom;
      this.endRentTo = this.$route.query.endRentTo;
      this.itemPerPage = this.$route.query.itemPerPage;
      this.searchBatch = this.$route.query.batch;
      this.sortByValue = this.$route.query.sortBy
        ? this.sortByOptions.find((e) => e.value === this.$route.query.sortBy)
        : "";

      this.currentPage = parseInt(this.$route.query.page);
      var status = [];
      for (var i = 0; i < this.searchStatus.length; i++) {
        status.push(this.searchStatus[i].status);
      }

      let arrTag = [];
      for (var i = 0; i < this.tagSearch.length; i++) {
        arrTag.push(this.tagSearch[i].tagId);
      }

      // this.getOrderTag()
      this.$http
        .post(
          process.env.SEARCH_ORDER,
          {
            orderCode: this.orderId,
            companyName: this.companyName,
            statusOrder: status,
            picId: this.searchPic.picId,
            startRentFrom: this.formatDate(this.startRentFrom),
            startRentTo: this.formatDate(this.startRentTo),
            endRentFrom: this.formatDate(this.endRentFrom),
            endRentTo: this.formatDate(this.endRentTo),
            tags: arrTag,
            batch: this.searchBatch,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
            sortBy: this.sortByValue.value,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            this.handleLogout();
          } else {
            let rawData = response.data.content.data;
            console.log("rawData", rawData);
            if (rawData) {
              for (var i = 0; i < rawData.length; i++) {
                let sortedTag = this.sortTag(rawData[i].orderTag);
                this.dataOrder = [
                  ...this.dataOrder,
                  { ...rawData[i], currentTags: sortedTag },
                ];
              }
            }

            this.totalPage = response.data.content.totalPage;
            this.totalData = response.data.content.totalData;
            this.currentPage = response.data.content.currentPage;
            this.loadingTable = false;
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });

      this.$http
        .get(process.env.GET_PIC_NAME, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            this.handleLogout();
          } else {
            this.picSelect = [];
            this.picSelect.push({
              picId: "All",
              picName: "All",
            });
            this.picSelect.push({
              picId: "0",
              picName: "None",
            });
            for (var i = 0; i < response.data.content.length; i++) {
              this.picSelect.push({
                picId: response.data.content[i].picId,
                picName: response.data.content[i].picName,
              });
            }
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    getOrderTag(id) {
      this.$http
        .get(process.env.GET_TAG + `/${id}`, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          // if (response.data.status == 400) {
          //       swal("Sorry", response.data.message, "error", {
          //             button: "Ok",
          //           })
          //       // this.handleLogout()
          //     }else{
          //       this.dataOrderTag = response.data.content.sort(function(a, b){return a.categoryId - b.categoryId})
          //       this.dataOrderTag.forEach(item => {
          //         this.selectedOrderTag.push({categoryName:item.categoryName, tags: item.tag})
          //       })
          //     }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    openModal(order) {
      this.companyId = order.companyId;
      this.openedModalOrderId = order.orderId;
      this.isOpenTagModal = true;
      this.statusSelectedOrder = order.status;
      this.currentEditTagOrderData = order;
      $(`#modalEditInvoiceTag`).modal("show");
    },
    cancelUpdateTag() {
      this.tagOrderFieldError = [];
      this.isOnTagOrderFieldError = false;
      this.selectedOrder.currentTags = { ...this.oldTags };
    },
    handleChangeChooseTag(e) {
      if (this.isOnTagOrderFieldError) {
        if (!this.selectedOrderTag[e] || this.selectedOrderTag[e].length <= 0) {
          this.tagOrderFieldError = [...this.tagOrderFieldError, e];
        } else {
          this.tagOrderFieldError = this.tagOrderFieldError.filter(
            (el) => el !== e
          );
        }
      }
    },
    submitUpdatedOrderTag() {
      let updatedTag = [];
      const warnField = [];
      this.dataOrderTag.forEach((el) => {
        if (
          !this.selectedOrderTag[el.categoryName] ||
          this.selectedOrderTag[el.categoryName].length <= 0
        ) {
          warnField.push(el.categoryName);
        }
      });
      if (warnField.length > 0) {
        this.isOnTagOrderFieldError = true;
        this.tagOrderFieldError = warnField;
        return null;
      }
      this.tagOrderFieldError = [];
      this.isOnTagOrderFieldError = false;
      for (const key in this.selectedOrderTag) {
        this.selectedOrderTag[key].forEach((item) => {
          updatedTag.push(item.tagId);
        });
      }

      this.updateOrderTag(this.selectedOrder.orderId, updatedTag);
    },
    updateOrderTag(orderId, updatedTag) {
      this.loadingButtonAdd = true;
      this.$http
        .post(
          process.env.UPDATE_ORDER_TAG,
          {
            orderId: orderId,
            tags: updatedTag,
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
          } else {
            $("#modalEditOrderTag").modal("hide");
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            this.getData();
          }
          this.loadingButtonAdd = false;
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    toCompanyDetail(id, status) {
      this.$router.push({
        path: "/partnership/lessee/detail/" + id,
        query: {
          companyStatus: status,
        },
      });
    },
  },
  created() {
    this.admin = localStorage.getItem("admin_name");
    this.cekLogin();
    this.cekPermission();
    this.getTag();
    this.getData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.pagination {
  padding: 0px 0;
}
.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}
.p8 a {
  background-color: #2797fb;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797fb;
}
.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}
.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.pagg {
  display: inline-flex;
  overflow: auto;
}
.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343a40;
}
#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}
#c1 {
  float: left;
}
#c2 {
  float: right;
}
.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}
.active {
  color: #2797fb;
}
.right-dropdown {
  margin-left: 7px;
}
.account-div {
  margin: 2px 2px;
}
.right-arrow {
  margin-left: auto;
}
.brand-logo {
  width: 120px;
}
.menu-title {
  margin-left: 1.125rem;
}
.menu-title-order {
  margin-left: 1.95rem;
}
.menu-title-payment {
  margin-left: 1.525rem;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}
li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}
li a.active {
  background-color: #4caf50;
  color: white;
}
li a:hover:not(.active) {
  background-color: #2797fb;
  color: white;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}
.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
  float: right;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

.tagColumn {
  display: inline-block;
}

.tagBadge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: #fff;
}

.btnEdit-sm {
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0rem 0.25rem;
  border-radius: 0.2rem;
}

.table thead th {
  text-align: center;
  vertical-align: middle;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Order/OrderPage.vue